import { render, staticRenderFns } from "./RelatorioLogPerfilTurmaLeitura.vue?vue&type=template&id=a6bccb84"
import script from "./RelatorioLogPerfilTurmaLeitura.vue?vue&type=script&lang=js"
export * from "./RelatorioLogPerfilTurmaLeitura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports